import type { FC, SVGProps } from 'react'

export const Delay: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.88573 11.7125L5.97225 3.33624C5.78713 2.80403 5 2.93702 5 3.5005V20.5816C5 21.145 5.78713 21.278 5.97225 20.7458L8.88573 12.3695C8.95974 12.1568 8.95974 11.9253 8.88573 11.7125Z"
      fill="currentColor"
    />
    <path
      d="M14.8825 11.7082L12.9715 6.29357C12.7844 5.76344 12 5.8978 12 6.45998V17.622C12 18.1842 12.7844 18.3186 12.9715 17.7884L14.8825 12.3738C14.9585 12.1585 14.9585 11.9236 14.8825 11.7082Z"
      fill="currentColor"
      fillOpacity="0.7"
    />
    <path
      d="M19.8757 11.6994L18.9699 9.20832C18.7787 8.68252 18 8.81971 18 9.37919V14.703C18 15.2625 18.7787 15.3997 18.9699 14.8739L19.8757 12.3828C19.956 12.1621 19.956 11.9201 19.8757 11.6994Z"
      fill="currentColor"
      fillOpacity="0.4"
    />
  </svg>
)
